
























































































































































































import { Observer } from 'mobx-vue'
import { Component, Provide, Ref, Vue } from 'vue-property-decorator'
import { StakingAdminViewModel } from '@/modules/staking-admin/viewmodels/staking-admin-viewmodel'
import { walletStore } from '@/stores/wallet-store'
import { StakingTypes } from '@/constants'

@Observer
@Component({
  components: {
    ConnectButton: () => import('@/components/ConnectButton.vue'),
    'multi-logo': () => import('@/components/multi-logo/multi-logo.vue')
  }
})
export default class extends Vue {
  @Provide() vm = new StakingAdminViewModel()
  walletStore = walletStore
  stakingTypes = StakingTypes

  headers = [
    {
      text: '-',
      value: 'index',
      sortable: false
    },
    {
      text: 'Staker',
      value: 'address',
      sortable: false
    },
    {
      text: 'Staked',
      value: 'amount',
      sortable: false
    }
  ]

  goToBsc(address) {
    window.open('https://bscscan.com/address/' + address, '_blank')
  }
}
